import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Link,
  CircularProgress,
} from "@material-ui/core";

import * as fb from "../../../../../../firebase/firebasejs";

// Tabla de folios "de más": un mismo inscrito con más de un folio vinculado
// en /inscritos/folios/ (bug de datos). El folio de más queda con dueño mas
// no representa a nadie -bloquea un número sin necesidad-, así que se ofrece
// liberarlo con la misma operación que "quitar reserva".
export default function FolioInconsistencies({ duplicados, onAbrirAtleta, onLiberado, eventoIndex }) {
  const [liberando, setLiberando] = useState(new Set());

  if (!duplicados.length) return null;

  function liberar(numero) {
    setLiberando((prev) => new Set(prev).add(numero));
    fb.db
      .ref(`${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.folios}num_${numero}`)
      .remove()
      .then(() => {
        onLiberado();
      })
      .finally(() => {
        setLiberando((prev) => {
          const next = new Set(prev);
          next.delete(numero);
          return next;
        });
      });
  }

  return (
    <Box mb={3}>
      <Typography variant="subtitle1" gutterBottom color="error">
        Folios duplicados detectados ({duplicados.length})
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Estos inscritos tienen más de un folio vinculado en la base de datos. El folio
        marcado abajo no representa a nadie y está bloqueando un número que podría asignarse al
        siguiente registro.
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Folio previo</TableCell>
              <TableCell>Atleta</TableCell>
              <TableCell>Folio actual asignado</TableCell>
              <TableCell align="right">Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {duplicados.map((d) => (
              <TableRow key={d.numero}>
                <TableCell>{d.numero}</TableCell>
                <TableCell>
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => onAbrirAtleta(d.inscritoKey)}
                  >
                    {d.nombreAtleta || d.inscritoKey}
                  </Link>
                </TableCell>
                <TableCell>
                  {d.ambiguo
                    ? "No identificado — revisar manualmente"
                    : d.folioLegitimo}
                </TableCell>
                <TableCell align="right">
                  <Button
                    size="small"
                    color="primary"
                    disabled={liberando.has(d.numero)}
                    startIcon={liberando.has(d.numero) ? <CircularProgress size={14} /> : null}
                    onClick={() => liberar(d.numero)}
                  >
                    Liberar folio previo (bloqueado)
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

FolioInconsistencies.propTypes = {
  duplicados: PropTypes.arrayOf(
    PropTypes.shape({
      numero: PropTypes.number,
      inscritoKey: PropTypes.string,
      nombreAtleta: PropTypes.string,
      folioLegitimo: PropTypes.number,
      ambiguo: PropTypes.bool,
    })
  ).isRequired,
  onAbrirAtleta: PropTypes.func.isRequired,
  onLiberado: PropTypes.func.isRequired,
  eventoIndex: PropTypes.string.isRequired,
};
